import createRouter, { generateRoutes } from '@/global/router'
import Login from '@/global/views/Login/index'
import store from '../store'

export const routeData = [
  {
    path: '/home',
    name: 'home',
    title: '首页面板',
    icon: 'icon-move',
    component: () => import('@/global/views/home-panel/index.vue'),
    meta: { platform: 'ad-user' }
  },
  {
    path: '/staff',
    name: 'staff',
    title: '员工管理',
    icon: 'icon-move',
    component: () => import('@/advertiser/views/staff/index.vue'),
    includePages: [
      {
        path: '/staff/:type/:id?',
        name: 'addStaff',
        component: () => import('@/advertiser/views/staff/add.vue')
      }
    ]
  },
  {
    name: 'AdPut',
    title: '广告投放',
    icon: 'icon-flag',
    children: [
      {
        path: '/advertisers',
        name: 'advertisers',
        title: '广告主管理',
        component: () => import('@/agent/views/ad-put/advertiser/index.vue')
      },
      {
        path: '/groups',
        name: 'groups',
        title: '广告组管理',
        meta: { platform: 'ad-user' },
        component: () => import('@/agent/views/ad-put/group/index.vue'),
        includePaths: ['/group/type', '/group/add', '/group/edit', '/group/view', 'group/copy'],
        includePages: [
          {
            path: '/group/:type/:id?',
            name: 'group/type',
            meta: { platform: 'ad-user' },
            component: () => import('@/agent/views/ad-put/group/add.vue')
          }
        ]
      },
      {
        path: '/plans',
        name: 'plans',
        meta: { platform: 'ad-user' },
        title: '计划管理',
        component: () => import('@/agent/views/ad-put/plan/index.vue'),
        includePaths: ['/plan/add', '/plan/edit', '/plan/view', '/plan/copy'],
        includePages: [
          {
            path: '/plan/add',
            name: 'plan/add',
            meta: { platform: 'ad-user' },
            component: () => import('@/agent/views/ad-put/plan/add.vue')
          },
          {
            path: '/plan/edit/:id',
            meta: { platform: 'ad-user' },
            name: 'plan/edit',
            component: () => import('@/agent/views/ad-put/plan/add.vue')
          },
          {
            path: '/plan/view/:id',
            meta: { platform: 'ad-user' },
            name: 'plan/view',
            component: () => import('@/agent/views/ad-put/plan/add.vue')
          },
          {
            path: '/plan/copy/:id',
            meta: { platform: 'ad-user' },
            name: 'plan/copy',
            component: () => import('@/agent/views/ad-put/plan/add.vue')
          }
        ]
      },
      {
        path: '/creations',
        name: 'creations',
        title: '创意管理',
        meta: { platform: 'ad-user' },
        component: () => import('@/agent/views/ad-put/creation/index.vue'),
        includePaths: ['/creation/type', '/creation/add', '/creation/edit', '/creation/view', 'creation/copy'],
        includePages: [
          {
            path: '/creation/:type/:id?',
            name: 'creation/type',
            meta: { platform: 'ad-user' },
            component: () => import('@/agent/views/ad-put/creation/add2.vue')
          }
        ]
      }
    ]
  },
  {
    name: 'ApplicationManage',
    title: '应用推广',
    icon: 'icon-flag',
    children: [
      {
        path: '/promotions',
        name: 'promotions',
        title: '推广管理',
        meta: { platform: 'ad-user' },
        component: () => import('@/agent/views/application/promotion/index.vue'),
        includePaths: ['/promotion/type', '/promotion/add', '/promotion/edit', '/promotion/view', 'promotion/copy'],
        includePages: [
          {
            path: '/promotion/:type/:id?',
            name: 'promotion/type',
            meta: { platform: 'ad-user' },
            component: () => import('@/agent/views/application/promotion/add.vue')
          }
        ]
      },
      {
        path: '/channels',
        name: 'channels',
        title: '渠道包管理',
        meta: { platform: 'ad-user' },
        component: () => import('@/agent/views/application/channel-pkg/index.vue'),
        includePaths: ['/channel/type', '/channel/add', '/channel/edit', '/channel/view'],
        includePages: [
          {
            path: '/channel/:type/:id?',
            name: 'channel/type',
            meta: { platform: 'ad-user' },
            component: () => import('@/agent/views/application/channel-pkg/add.vue')
          }
        ]
      }
    ]
  },
  // {
  //   path: '/promotion-data',
  //   name: 'promotion-data',
  //   title: '推广数据',
  //   icon: 'icon-pie',
  //   meta: { platform: 'ad-user' },
  //   component: () => import('@/agent/views/promotion/data.vue')
  // },
  /* {
    name: 'advertisePut',
    title: '广告投放',
    icon: 'icon-flag',
    children: [
      {
        path: '/orderList/nofilter',
        name: 'orderList',
        title: '计划管理',
        meta: { platform: 'ad-user' },
        component: () => import('@/advertiser/views/advertise_put/order_list.vue'),
        includePaths: ['/orderAdd', '/orderOpr'],
        includePages: [
          {
            path: '/orderAdd',
            name: 'orderAdd',
            meta: { platform: 'ad-user' },
            component: () => import('@/advertiser/views/advertise_put/order_opr.vue')
          },
          {
            path: '/orderOpr/:id/:type',
            name: 'orderOpr',
            meta: { platform: 'ad-user' },
            component: () => import('@/advertiser/views/advertise_put/order_opr.vue')
          }
        ]
      },
      {
        path: '/advertiseList',
        name: 'advertiseList',
        title: '广告管理',
        component: () => import('@/advertiser/views/advertise_put/advertise_list.vue'),
        includePaths: ['/advertiseAdd'],
        includePages: [
          {
            path: '/advertiseAdd/:type?/:id?',
            name: 'advertiseAdd',
            component: () => import('@/advertiser/views/advertise_put/advertise_opr.vue')
          }
        ]
      }
    ]
  }, */
  {
    path: '/dataReport',
    name: 'dataReport',
    title: '数据报表',
    icon: 'icon-pie',
    meta: { platform: 'ad-user' },
    component: () => import('@/global/views/data_report_ad.vue')
  },
  {
    path: '/audience',
    name: 'audience',
    title: '受众分析',
    icon: 'icon-pie',
    meta: { platform: 'ad-user' },
    component: () => import('@/global/views/audience-analysis/index.vue')
  },
  {
    path: '/finDetails',
    name: 'finDetails',
    title: '财务明细',
    icon: 'icon-icon15',
    component: () => import('@/advertiser/views/financial/finDetails.vue')
  },
  {
    name: 'account',
    title: '账号管理',
    icon: 'icon-zhanghaoguanli',
    children: [
      {
        path: '/accountInfo',
        name: 'accountInfo',
        title: '账户详情',
        component: () => import('@/advertiser/views/account/accountInfo.vue')
      },
      {
        path: '/passwordSet',
        name: 'passwordSet',
        title: '密码设置',
        component: () => import('@/advertiser/views/account/passwordSet.vue')
      }
    ]
  },
  {
    path: 'tool',
    name: 'tool',
    title: '工具',
    icon: 'icon-flag',
    meta: { platform: 'ad-user' },
    children: [
      {
        name: 'operationLog',
        path: '/operationLog',
        meta: { platform: 'ad-user' },
        title: '操作日志',
        component: () => import('@/global/views/tool/operationLog.vue')
      },
      {
        name: 'transferEvent',
        path: '/transferEvent',
        meta: { platform: 'ad-user' },
        title: '转化事件管理',
        component: () => import('@/global/views/tool/transferEvent.vue')
      },
      {
        name: 'track',
        path: '/track',
        meta: { platform: 'ad-user' },
        title: '转化追踪',
        component: () => import('@/advertiser/views/track/index.vue'),
        includePages: [
          {
            path: '/track/:type/:id?',
            name: 'operateTrack',
            meta: { platform: 'ad-user' },
            component: () => import('@/advertiser/views/track/add.vue')
          }
        ]
      }
    ]
  }
]

let routeDataFilter = routeData.filter(item => {
  // eslint-disable-next-line no-undef
  return item.name === 'audience' && VUE_APP_ENV === 'online' ? false : item
})
const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { platform: 'ad-user' }
  },
  {
    path: '/',
    name: 'main',
    meta: { platform: 'ad-user' },
    component: () => import('@/advertiser/views/main.vue'),
    children: generateRoutes(routeDataFilter, true)
  }
]
export default createRouter({ base: '/advertiser/', routes, routeData: routeDataFilter }, store, 'ad-user')
